module.exports = __webpack_public_path__ + "media/images/pages/fcr/component-3-cf05b67c693a9db0bc9a373ed46cd013.jpg";